export const ADMIN_TABLE_FETCH_SIZE = 20;

export const genders = {
    "M": "Male",
    "F": "Female",
}

export const fighterRequestStatus = {
    pending: "PENDING",
    approved: "APPROVED",
    rejected: "REJECTED",
};

export const statusBgClasses = {
    pending: "bg-yellow-400",
    approved: "bg-success",
    rejected: "bg-error",
};
export const fighterRequestType = {
    newRegister: "NEW_REGISTER",
    updateInfo: "UPDATE_INFO",
    registerEvent: "REGISTER_EVENT",
    weightChange: "WEIGHT_CHANGE",
};

export const paymentMethod = {
    slip: "SLIP",
    token: "TOKEN",
};

export const tokenStatus = {
    active: "ACTIVE",
    used: "USED",
};

export const AGREEMENT_VERSION = "1.0";
export const AGREEMENT_COUNTDOWN_SECONDS = 10;

export const weightClasses = {
    A: "Atomweight (48 kg)",
    B: "Strawweight 115 lb (52.2 kg)",
    C: "Flyweight 125 lb (56.7 kg)",
    D: "Bantamweight 135 lb (61.2 kg)",
    E: "Featherweight 145 lb (65.8 kg)",
    F: "Lightweight 155 lb (70.3 kg)",
    G: "Welterweight 170 lb (77.1 kg)",
    H: "Middleweight 185 lb (83.9 kg)",
    I: "Light Heavyweight 205 lb (93.0 kg)",
    J: "Heavyweight 265 lb (120.2 kg)",
    K: "Super Heavyweight (> 120 kg)",
};

export const weightClassesName = {
    A: "Atomweight",
    B: "Strawweight",
    C: "Flyweight",
    D: "Bantamweight",
    E: "Featherweight",
    F: "Lightweight",
    G: "Welterweight",
    H: "Middleweight",
    I: "Light Heavyweight",
    J: "Heavyweight",
    K: "Super Heavyweight",
};

export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const monthMap = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
};

export const fighterEntryDisplayMapping = {
    BOXING: "Boxing",
    MUAY_THAI: "Muay Thai",
    KICKBOXING: "Kickboxing",
    MMA: "MMA",
};

// Admin fighter list rows (All / Pulled Out / Refund Records tabs) are marked
// by discipline: a solid left edge, a faint flat tint and the discipline name
// in the same hue. Tints stay low because on the black theme a strong yellow
// or green fill turns muddy. Full class names so Tailwind keeps them.
export const fighterEntryHighlightClasses = {
    BOXING: { row: "border-l-4 border-blue-500 bg-blue-500/10", text: "text-blue-300" },
    MUAY_THAI: { row: "border-l-4 border-red-500 bg-red-500/10", text: "text-red-300" },
    KICKBOXING: { row: "border-l-4 border-yellow-400 bg-yellow-400/[.07]", text: "text-yellow-300" },
    MMA: { row: "border-l-4 border-green-500 bg-green-500/10", text: "text-green-300" },
};

export const fighterEntryTooltipMapping = {
    BOXING: "BX",
    MUAY_THAI: "MT",
    KICKBOXING: "KB",
    MMA: "MMA",
};

export const eventStatusTooltipMapping = {
    A: "Active",
    I: "Inactive",
};

export const eventStatusColorMapping = {
    CM: "yellow",
    AC: "green",
    EE: "red",
};

export const fighterEnties = ["BOXING", "MUAY_THAI", "KICKBOXING", "MMA"];

export const nationalities = [
    "Malaysian",
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "Andorran",
    "Angolan",
    "Antiguans",
    "Argentinean",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbadian",
    "Barbudans",
    "Batswana",
    "Belarusian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bhutanese",
    "Bolivian",
    "Bosnian",
    "Brazilian",
    "British",
    "Bruneian",
    "Bulgarian",
    "Burkinabe",
    "Burmese",
    "Burundian",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Cape Verdean",
    "Central African",
    "Chadian",
    "Chilean",
    "Chinese",
    "Colombian",
    "Comoran",
    "Congolese",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cypriot",
    "Czech",
    "Danish",
    "Djibouti",
    "Dominican",
    "Dutch",
    "East Timorese",
    "Ecuadorean",
    "Egyptian",
    "Emirian",
    "Equatorial Guinean",
    "Eritrean",
    "Estonian",
    "Ethiopian",
    "Fijian",
    "Filipino",
    "Finnish",
    "French",
    "Gabonese",
    "Gambian",
    "Georgian",
    "German",
    "Ghanaian",
    "Greek",
    "Grenadian",
    "Guatemalan",
    "Guinea-Bissauan",
    "Guinean",
    "Guyanese",
    "Haitian",
    "Herzegovinian",
    "Honduran",
    "Hungarian",
    "I-Kiribati",
    "Icelander",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivorian",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kazakhstani",
    "Kenyan",
    "Kittian and Nevisian",
    "Kuwaiti",
    "Kyrgyz",
    "Laotian",
    "Latvian",
    "Lebanese",
    "Liberian",
    "Libyan",
    "Liechtensteiner",
    "Lithuanian",
    "Luxembourger",
    "Macedonian",
    "Malagasy",
    "Malawian",
    "Maldivan",
    "Malian",
    "Maltese",
    "Marshallese",
    "Mauritanian",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldovan",
    "Monacan",
    "Mongolian",
    "Moroccan",
    "Mosotho",
    "Motswana",
    "Mozambican",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "New Zealander",
    "Nicaraguan",
    "Nigerian",
    "Nigerien",
    "North Korean",
    "Northern Irish",
    "Norwegian",
    "Omani",
    "Pakistani",
    "Palauan",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Polish",
    "Portuguese",
    "Qatari",
    "Romanian",
    "Russian",
    "Rwandan",
    "Saint Lucian",
    "Salvadoran",
    "Samoan",
    "San Marinese",
    "Sao Tomean",
    "Saudi",
    "Scottish",
    "Senegalese",
    "Serbian",
    "Seychellois",
    "Sierra Leonean",
    "Singaporean",
    "Slovakian",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Korean",
    "Spanish",
    "Sri Lankan",
    "Sudanese",
    "Surinamer",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Taiwanese",
    "Tajik",
    "Tanzanian",
    "Thai",
    "Togolese",
    "Tongan",
    "Trinidadian or Tobagonian",
    "Tunisian",
    "Turkish",
    "Tuvaluan",
    "Ugandan",
    "Ukrainian",
    "Uruguayan",
    "Uzbekistani",
    "Venezuelan",
    "Vietnamese",
    "Welsh",
    "Yemenite",
    "Zambian",
    "Zimbabwean",
];

export const authMethods = {
    EMAIL: "password",
    PHONE: "phone",
    GOOGLE: "google.com",
    FACEBOOK: "facebook.com",
    TWITTER: "twitter.com",
    GITHUB: "github.com"
};

export const authIdentifierNames = {
    [authMethods.EMAIL]: "email",
    [authMethods.PHONE]: "phoneNumber",
    [authMethods.GOOGLE]: "email",
    [authMethods.FACEBOOK]: "email",
    [authMethods.TWITTER]: "username",
    [authMethods.GITHUB]: "email"
};

export const countryDialCodes = [
    { code: "+60", country: "Malaysia" },
    { code: "+65", country: "Singapore" },
    { code: "+66", country: "Thailand" },
    { code: "+62", country: "Indonesia" },
    { code: "+63", country: "Philippines" },
    { code: "+84", country: "Vietnam" },
    { code: "+86", country: "China" },
    { code: "+81", country: "Japan" },
    { code: "+82", country: "South Korea" },
    { code: "+91", country: "India" },
    { code: "+1", country: "United States" },
    { code: "+44", country: "United Kingdom" },
    { code: "+61", country: "Australia" },
    { code: "+64", country: "New Zealand" },
    { code: "+33", country: "France" },
    { code: "+49", country: "Germany" },
    { code: "+39", country: "Italy" },
    { code: "+34", country: "Spain" },
    { code: "+7", country: "Russia" },
    { code: "+55", country: "Brazil" },
    { code: "+52", country: "Mexico" },
    { code: "+54", country: "Argentina" },
    { code: "+27", country: "South Africa" },
    { code: "+20", country: "Egypt" },
    { code: "+971", country: "United Arab Emirates" },
    { code: "+966", country: "Saudi Arabia" },
    { code: "+98", country: "Iran" },
    { code: "+90", country: "Turkey" },
    { code: "+380", country: "Ukraine" },
    { code: "+48", country: "Poland" },
    { code: "+46", country: "Sweden" },
    { code: "+47", country: "Norway" },
    { code: "+358", country: "Finland" },
    { code: "+45", country: "Denmark" },
    { code: "+31", country: "Netherlands" },
    { code: "+32", country: "Belgium" },
    { code: "+41", country: "Switzerland" },
    { code: "+43", country: "Austria" },
    { code: "+36", country: "Hungary" },
    { code: "+420", country: "Czech Republic" },
    { code: "+421", country: "Slovakia" },
    { code: "+385", country: "Croatia" },
    { code: "+353", country: "Ireland" },
    { code: "+351", country: "Portugal" },
    { code: "+30", country: "Greece" },
    { code: "+40", country: "Romania" },
    { code: "+359", country: "Bulgaria" },
    { code: "+385", country: "Croatia" },
    { code: "+386", country: "Slovenia" },
    { code: "+387", country: "Bosnia and Herzegovina" },
    { code: "+382", country: "Montenegro" },
    { code: "+383", country: "Kosovo" },
    { code: "+355", country: "Albania" },
    { code: "+356", country: "Malta" },
    { code: "+357", country: "Cyprus" },
    { code: "+372", country: "Estonia" },
    { code: "+371", country: "Latvia" },
    { code: "+370", country: "Lithuania" },
    { code: "+352", country: "Luxembourg" },
    { code: "+423", country: "Liechtenstein" },
    { code: "+377", country: "Monaco" },
    { code: "+378", country: "San Marino" },
    { code: "+379", country: "Vatican City" },
    { code: "+376", country: "Andorra" },
    { code: "+354", country: "Iceland" },
    { code: "+298", country: "Faroe Islands" },
    { code: "+299", country: "Greenland" },
    { code: "+500", country: "Falkland Islands" },
    { code: "+672", country: "Norfolk Island" },
    { code: "+677", country: "Solomon Islands" },
    { code: "+678", country: "Vanuatu" },
    { code: "+679", country: "Fiji" },
    { code: "+680", country: "Palau" },
    { code: "+681", country: "Wallis and Futuna" },
    { code: "+682", country: "Cook Islands" },
    { code: "+683", country: "Niue" },
    { code: "+685", country: "Samoa" },
    { code: "+686", country: "Kiribati" },
    { code: "+687", country: "New Caledonia" },
    { code: "+688", country: "Tuvalu" },
    { code: "+689", country: "French Polynesia" },
    { code: "+690", country: "Tokelau" },
    { code: "+691", country: "Micronesia" },
    { code: "+692", country: "Marshall Islands" },
    { code: "+850", country: "North Korea" },
    { code: "+852", country: "Hong Kong" },
    { code: "+853", country: "Macau" },
    { code: "+855", country: "Cambodia" },
    { code: "+856", country: "Laos" },
    { code: "+880", country: "Bangladesh" },
    { code: "+886", country: "Taiwan" },
    { code: "+960", country: "Maldives" },
    { code: "+961", country: "Lebanon" },
    { code: "+962", country: "Jordan" },
    { code: "+963", country: "Syria" },
    { code: "+964", country: "Iraq" },
    { code: "+965", country: "Kuwait" },
    { code: "+966", country: "Saudi Arabia" },
    { code: "+967", country: "Yemen" },
    { code: "+968", country: "Oman" },
    { code: "+970", country: "Palestine" },
    { code: "+972", country: "Israel" },
    { code: "+973", country: "Bahrain" },
    { code: "+974", country: "Qatar" },
    { code: "+975", country: "Bhutan" },
    { code: "+976", country: "Mongolia" },
    { code: "+977", country: "Nepal" },
    { code: "+992", country: "Tajikistan" },
    { code: "+993", country: "Turkmenistan" },
    { code: "+994", country: "Azerbaijan" },
    { code: "+995", country: "Georgia" },
    { code: "+996", country: "Kyrgyzstan" },
    { code: "+998", country: "Uzbekistan" }
].sort((a, b) => a.country.localeCompare(b.country));
